export default {"stars":"_85ZJ4","star":"disV-"};